// extracted by mini-css-extract-plugin
export default {"root":"_2t2q1","left":"_1u6is","right":"_37GVa"};